export default __webpack_public_path__ + "static/media/LonelyWoman60s.657b20f0.mp3";